import React, {
  Fragment,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';
import { LIST_COUNT_PER_PAGE } from '@common/constants';

const SmartTableMobile = ({
  data,
  className,
  columnConfig,
  hasPagination,
  countPerPage,
  rowClick,
}) => {
  const t = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const currentData = useMemo(() => {
    if (!hasPagination) return data;

    return data.slice(0, currentPage * (countPerPage || LIST_COUNT_PER_PAGE));
  }, [data, currentPage, hasPagination, countPerPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const headerColumnConfig = columnConfig
    .filter((col) => col.mobile?.headerPlacement)
    .sort((a, b) => {
      if (a.mobile.headerPlacement === b.mobile.headerPlacement) return 0;
      if (a.mobile.headerPlacement === 'left') return -1;
      if (b.mobile.headerPlacement === 'left') return 1;
      return 0;
    });

  const contentColumnConfig = columnConfig.filter((col) => !col.mobile?.headerPlacement);

  return (
    <div className={`mobile-smart-table-wrapper ${className || ''}`}>
      <div className="mobile-smart-table-list">
        {currentData.map((item, index) => (
          <div key={index} className="mobile-smart-table-list-item" onClick={() => rowClick?.(item, index)}>
            <div className="mobile-smart-table-item-header">
              {headerColumnConfig.map((col, colIndex) => (
                <div key={colIndex} className={`mobile-smart-table-header-${col.mobile.headerPlacement} ${col.mobile.columnClassName || ''}`}>
                  {col.row(item, index)}
                </div>
              ))}
            </div>
            <div className="mobile-smart-table-item-content">
              {contentColumnConfig.map((col, colIndex) => {
                const colName = typeof col.name === 'function'
                  ? col.name()
                  : t(col.name);

                return (
                  <div key={colIndex} className={`mobile-smart-table-column ${col.mobile?.columnClassName || ''}`}>
                    <div className="mobile-smart-table-column-name">{colName}</div>
                    <div className="mobile-smart-table-column-value">
                      {col.row(item, index)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {!!hasPagination && currentData.length < data.length && (
        <div className="mobile-smart-table-load-more">
          <button type="button" onClick={() => setCurrentPage(currentPage + 1)}>{t('Load more')}</button>
        </div>
      )}
    </div>
  );
};

SmartTableMobile.propTypes = {
  hasPagination: PropTypes.bool,
  countPerPage: PropTypes.number,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  columnConfig: PropTypes.array.isRequired,
  rowClick: PropTypes.func,
};

export default SmartTableMobile;
